import React from 'react';

import Why from './why';

export default React.memo(Why);
